import React, { useEffect, useState } from "react";
import { processOrder, getRedirect } from "../service/service";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../../common/header/Header";

const ProcessOrder = () => {
  let { id } = useParams();
  let nav = useNavigate();
  let [state, setState] = useState({});
  let [trigger, setTrigger] = useState(false);

  useEffect(() => {
    processOrder(id, state, setState, setTrigger, false);
  }, []);

  return (
    <div className="campaign-content">
      <div className="page_wrapper">
        <div className="header-wrapper">
          <Header />
      <div className="loaderdot">
              <div class="loading-dots">
                <div class="loading-dots--dot"></div>
                <div class="loading-dots--dot"></div>
                <div class="loading-dots--dot"></div>
              </div>
            </div>
    </div>
        </div>
      </div>
  );
};

export default ProcessOrder;
